export const REMOVE_USER_START = "REMOVE_USER_START";
export const REMOVE_USER_SUCCESS = "REMOVE_USER_SUCCESS";
export const REMOVE_USER_FAIL = "REMOVE_USER_FAIL";

export const GET_USER_START = "GET_USER_START";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";

export const EDIT_USER_START = "EDIT_USER_START";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_FAIL = "EDIT_USER_FAIL";

export const GET_USERS_START = "GET_USERS_START";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";

export const CREATE_USER_START = "CREATE_USER_START";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";

export const CLEAR_USER = "CLEAR_USER";

export const GET_USER_GROUPS_START = "GET_USER_GROUPS_START";
export const GET_USER_GROUPS_SUCCESS = "GET_USER_GROUPS_SUCCESS";
export const GET_USER_GROUPS_FAIL = "GET_USER_GROUPS_FAIL";

export const GET_USER_GROUP_START = "GET_USER_GROUP_START";
export const GET_USER_GROUP_SUCCESS = "GET_USER_GROUP_SUCCESS";
export const GET_USER_GROUP_FAIL = "GET_USER_GROUP_FAIL";

export const EDIT_USER_GROUP_START = "EDIT_USER_GROUP_START";
export const EDIT_USER_GROUP_SUCCESS = "EDIT_USER_GROUP_SUCCESS";
export const EDIT_USER_GROUP_FAIL = "EDIT_USER_GROUP_FAIL";



// WEBPACK FOOTER //
// ./src/system/store/AdminUsers/types.js